import { useState, type ReactNode } from 'react';

export function CollapsiblePanel({
	title,
	defaultOpen = true,
	className = '',
	children,
}: {
	title: string;
	defaultOpen?: boolean;
	className?: string;
	children: ReactNode;
}) {
	const [open, setOpen] = useState(defaultOpen);
	return (
		<details className={`panel collapsible-panel ${className}`} open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
			<summary>
				<h2>{title}</h2>
			</summary>
			<div className="collapsible-panel-body">{children}</div>
		</details>
	);
}
